import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { z } from 'zod';
import { parseUrlParam } from '~/components/Filter';

const TAG_SCHEMA = z.array(z.string());
const PUBLISHED_SCHEMA = z.array(z.boolean());

export const getDesignFiltersParams = (searchParams: URLSearchParams) => ({
  tags: parseUrlParam(() => TAG_SCHEMA.parse(JSON.parse(searchParams.get('tags') || '[]')), 'tags'),
  published: parseUrlParam(
    () => PUBLISHED_SCHEMA.parse(JSON.parse(searchParams.get('published') || '[]')),
    'published',
  ),
});

export const useDesignFiltersParams = () => {
  const [searchParams] = useSearchParams();
  const [_, setSavedParamsString] = useLocalStorage('studio:filters', '');

  // Save to local storage whenever URL params change
  useEffect(() => {
    setSavedParamsString(() => searchParams.toString());
  }, [searchParams, setSavedParamsString]);

  return useMemo(() => getDesignFiltersParams(searchParams), [searchParams]);
};
